<template>
  <section class="auth-form">
    <AuthPageHeader title="Confirm Email Address" />
    <p>Click below to confirm your email address and activate your ThreeFlow account.</p>
    <div class="btn-group">
      <AppButton
        type="primary"
        text="Confirm email"
        no-branding
      />
    </div>
    <AuthPageFooter />
  </section>
</template>

<script>
  export default {
    name: 'AppConfirmEmail',
    props: {
      confirmEmailLink: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    justify-content: center;
  }
</style>
